import {
  TagsInput as MantineTagsInput,
  TagsInputProps as MantineTagsInputProps,
} from "@mantine/core"
import { forwardRef } from "react"

export type TagsInputProps = Omit<MantineTagsInputProps, "component">

export const TagsInput = forwardRef<HTMLInputElement, TagsInputProps>(
  ({ label, error, required, ...props }, ref) => {
    return (
      <MantineTagsInput
        ref={ref}
        label={label}
        error={error}
        required={required}
        {...props}
      />
    )
  }
)

TagsInput.displayName = "TagsInput"
